const namespace = 'configure'

export const loadingSelector = state => {
  return state[namespace].get('fetching')
}

export const entriesSelectors = state => {
  return state[namespace].get('entries')
}
export const addressSelectors = state => {
  return state[namespace].get('address')
}
export const demandSelectors = state => {
  return state[namespace].get('demand')
}
export const totalSelector = state => {
  return state[namespace].get('total')
}
